import { cn } from '#lib/helpers/class.js';
import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '@iconify-icon/react';

export default function FeedbackCard(props) {
    const { id, fullName, description, rating, created, planName } = props;

    const handleShowText = () => {
        setShowText(!showText);
        setIsOverflowing(!isOverflowing);
    };

    const cardRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [showText, setShowText] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            const card = cardRef.current;
            if (card.scrollHeight > card.clientHeight) {
                setIsOverflowing(true);
            } else {
                setShowText(false);
                setIsOverflowing(false);
            }
        };

        checkOverflow();
        window.addEventListener('resize', checkOverflow);

        return () => window.removeEventListener('resize', checkOverflow);
    }, [cardRef, description]);

    return (
        <div id={id} className="feedback flex flex-col w-full border border-neutral-400 rounded-md p-2 gap-y-1">
            <div className="flex flex-col">
                <div className="flex justify-between">
                    <span>{fullName || _t.edit.anonymous()}</span>
                    <span>{created}</span>
                </div>
                <div>
                    {Array(5)
                        .fill('', 0, 5)
                        .map((_, i) => {
                            if (i < rating)
                                return (
                                    <Icon
                                        icon="material-symbols-light:star"
                                        height="1.2rem"
                                        width="1.2rem"
                                        className="text-amber-500"
                                    />
                                );
                            else
                                return (
                                    <Icon
                                        icon="material-symbols-light:star-outline"
                                        height="1.2rem"
                                        width="1.2rem"
                                        className="text-amber-500"
                                    />
                                );
                        })}
                </div>
            </div>
            {planName ? <span className="font-semibold">{planName}</span> : null}
            <div className="h-30 overflow-hidden">
                <div
                    className={cn(
                        'text-ellipsis line-clamp-3 text-justify',
                        showText && 'line-clamp-none',
                        isOverflowing && 'cursor-pointer'
                    )}
                    onClick={handleShowText}
                    ref={cardRef}
                >
                    {description ?? ''}
                </div>
                {showText && (
                    <div
                        className="py-3 text-sm font-semibold hover:text-primary-600 cursor-pointer"
                        onClick={handleShowText}
                    >
                        {_t.edit.seeLess()}
                    </div>
                )}
            </div>
        </div>
    );
}
